import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  return <section className="bg-[#F0F5F0] py-16 md:py-24 px-4" data-id="element-326">
      <div className="max-w-6xl mx-auto" data-id="element-327">
        <h2 className="text-[28px] md:text-[40px] font-playfair font-bold text-marron text-center mb-12" data-id="element-328">
          💬 LO QUE DICEN OTRAS MUJERES
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-329">
          {/* Testimonial 1 */}
          <div className="bg-white p-8 rounded-2xl shadow-card relative" data-id="element-330">
            <div className="flex text-terracota mb-4" data-id="element-331">
              <Star className="w-5 h-5 fill-current" data-id="element-332" />
              <Star className="w-5 h-5 fill-current" data-id="element-333" />
              <Star className="w-5 h-5 fill-current" data-id="element-334" />
              <Star className="w-5 h-5 fill-current" data-id="element-335" />
              <Star className="w-5 h-5 fill-current" data-id="element-336" />
            </div>
            <p className="text-carbon/80 italic mb-6 text-[15px] leading-relaxed" data-id="element-337">
              "Llevaba dos años tomando colágeno en polvo. Dos años y $1,400
              después. Cuando leí la explicación de por qué no funciona quise
              llorar. Empecé el protocolo y en 45 días noté la diferencia en la
              textura. Mi piel se siente más densa y firme."
            </p>
            <div className="flex items-center" data-id="element-338">
              <div className="w-12 h-12 bg-verde/20 rounded-full flex items-center justify-center text-verde font-bold text-xl mr-4" data-id="element-339">
                L
              </div>
              <div data-id="element-340">
                <p className="font-bold text-marron" data-id="element-341">Lucía R.</p>
                <p className="text-sm text-carbon/60" data-id="element-342">52 años, México</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-white p-8 rounded-2xl shadow-card relative" data-id="element-343">
            <div className="flex text-terracota mb-4" data-id="element-344">
              <Star className="w-5 h-5 fill-current" data-id="element-345" />
              <Star className="w-5 h-5 fill-current" data-id="element-346" />
              <Star className="w-5 h-5 fill-current" data-id="element-347" />
              <Star className="w-5 h-5 fill-current" data-id="element-348" />
              <Star className="w-5 h-5 fill-current" data-id="element-349" />
            </div>
            <p className="text-carbon/80 italic mb-6 text-[15px] leading-relaxed" data-id="element-350">
              "Las recetas son deliciosas. El salmón con piel al limón se
              convirtió en el favorito de toda mi familia. Nadie sabe que es
              'terapéutico'. Y yo sigo siendo la que mejor se ve en las
              reuniones."
            </p>
            <div className="flex items-center" data-id="element-351">
              <div className="w-12 h-12 bg-verde/20 rounded-full flex items-center justify-center text-verde font-bold text-xl mr-4" data-id="element-352">
                V
              </div>
              <div data-id="element-353">
                <p className="font-bold text-marron" data-id="element-354">Valentina M.</p>
                <p className="text-sm text-carbon/60" data-id="element-355">44 años, Argentina</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-white p-8 rounded-2xl shadow-card relative" data-id="element-356">
            <div className="flex text-terracota mb-4" data-id="element-357">
              <Star className="w-5 h-5 fill-current" data-id="element-358" />
              <Star className="w-5 h-5 fill-current" data-id="element-359" />
              <Star className="w-5 h-5 fill-current" data-id="element-360" />
              <Star className="w-5 h-5 fill-current" data-id="element-361" />
              <Star className="w-5 h-5 fill-current" data-id="element-362" />
            </div>
            <p className="text-carbon/80 italic mb-6 text-[15px] leading-relaxed" data-id="element-363">
              "En 3 semanas ya no me levantaba con la cara 'aplastada'. Al mes y
              medio una amiga me preguntó qué me había hecho. No le dije nada.
              Solo sonreí."
            </p>
            <div className="flex items-center" data-id="element-364">
              <div className="w-12 h-12 bg-verde/20 rounded-full flex items-center justify-center text-verde font-bold text-xl mr-4" data-id="element-365">
                C
              </div>
              <div data-id="element-366">
                <p className="font-bold text-marron" data-id="element-367">Carmen F.</p>
                <p className="text-sm text-carbon/60" data-id="element-368">49 años, España</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}